<template>
	<el-dialog title="拍照&裁剪图片" :visible.sync="data.visible" width="1330px" center :close-on-click-modal="false"
		@closed="toCloseClick">
		<el-form class="cropperForm">
			<el-form-item label="选择照片:">
				<input ref="img" type="file" accept="image/*" @change="selectImage" />
			</el-form-item>
			<el-row :gutter="20">
				<el-col :span="12">
					<el-card style="height: 450px;">
						<div slot="header" class="clearfix">
							<span>原始图片</span>
						</div>
						<div class="cropper" style="text-align:center;height:378px;">
							<VueCropper ref="cropper" :img="data.option.img" :outputSize="data.option.outputSize"
								:outputType="data.option.outputType" :info="data.option.info" :mode="data.option.mode"
								:canScale="data.option.canScale" :autoCrop="data.option.autoCrop"
								:autoCropWidth="data.option.autoCropWidth" :autoCropHeight="data.option.autoCropHeight"
								:fixed="data.option.fixed" :fixedBox="data.option.fixedBox"
								:fixedNumber="data.option.fixedNumber" :full="data.option.full"
								:original="data.option.original" :centerBox="data.option.centerBox"
								:infoTrue="data.option.infoTrue" :canMove="data.option.canMove"
								:canMoveBox="data.option.canMoveBox" :high="data.option.high"
								:enlarge="data.option.enlarge" @realTime="VueCropperRealTime">
							</VueCropper>
						</div>
					</el-card>
				</el-col>
				<el-col :span="12">
					<el-card style="height: 450px;">
						<div slot="header" class="clearfix">
							<span>处理后的图片</span>
						</div>
						<div class="show-preview" style="width:624px;height:378px;">
							<img ref="prevImg" :src="data.preview"
								style="width:624px;height:378px;object-fit:contain;" />
							<!--<div :style="data.previews.div" class="preview">
								<img :src="data.previews.url" :style="data.previews.img">
							</div>-->
						</div>
					</el-card>
				</el-col>
			</el-row>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button type="primary" icon="el-icon-check" @click="toOkClick('blob')" :disabled="!data.canok">确定
			</el-button>
			<el-button type="primary" icon="el-icon-close" @click="toCloseClick">取消</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import {
		VueCropper
	} from 'vue-cropper';
	export default {
		data() {
			return {
				data: {
					selectFileList: [],
					preview: '',
					//previews: {},
					option: {
						img: '', // 裁剪图片的地址
						info: true, // 裁剪框的大小信息
						outputSize: 1, // 裁剪生成图片的质量
						outputType: 'jpg', // 裁剪生成图片的格式
						canScale: true, // 图片是否允许滚轮缩放
						autoCrop: true, // 是否默认生成截图框
						autoCropWidth: 270, // 默认生成截图框宽度
						autoCropHeight: 378, // 默认生成截图框高度
						fixedBox: true, // 固定截图框大小 不允许改变
						fixed: true, // 是否开启截图框宽高固定比例
						fixedNumber: [5, 7], // 截图框的宽高比例
						full: true, // 是否输出原图比例的截图
						centerBox: true, // 截图框是否被限制在图片里面
						infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
						canMove: true, //上传图片是否可以移动
						canMoveBox: false, // 截图框能否拖动
						original: false, //上传图片按照原始比例渲染
						high: true, //是否按照设备的dpr 输出等比例图片
						enlarge: 1, //图片根据截图框输出比例倍数,值范围：0-max(建议不要太大不然会卡死)
						mode: 'auto' //图片默认渲染方式，值范围：contain , cover, 100px, 100% auto
					},
					camera: {
						doing: false,
						width: 1280,
						height: 720
					},
					fileName: '',
					visible: false,
					canok: false
				}

			}
		},
		components: {
			'VueCropper': VueCropper
		},
		props: {
			autoCropWidth: Number,
			autoCropHeight: Number
		},
		methods: {
			init() {
				let ths = this;
				ths.data.visible = true;
				ths.data.selectFileList = [];
				ths.data.preview = '';
				//ths.data.previews = {};
				ths.data.fileName = '';
				ths.data.option.img = '';
				ths.data.option.autoCropWidth = ths.autoCropWidth;
				ths.data.option.autoCropHeight = ths.autoCropHeight;
				setTimeout((t) => {
					t.$refs.img.value = '';
				}, 50, ths);
			},
			handleUploadViolationImageSuccess(response, file, fileList) {
				if (!file.request) {
					this.data.option.img = URL.createObjectURL(file.raw);
					this.data.selectFileList = [];
				}
			},
			handleUploadViolationImageError(err, file, fileList) {},
			handleUploadViolationImageChange(file, fileList) {
				if (!file.request) {
					this.data.option.img = URL.createObjectURL(file.raw);
					this.data.selectFileList = [];
				}
			},
			VueCropperRealTime(data) {
				let ths = this;
				//ths.data.previews = data;
				ths.$refs.cropper.getCropBlob((blob) => {
					ths.data.preview = blob.getURL();
					ths.data.canok = true;
				});
			},
			toOkClick(type) {
				let ths = this;
				//输出blob
				ths.$refs.cropper.getCropBlob((data) => {
					ths.$emit('toOk', data, 'location');
					ths.data.visible = false;
				});
			},
			toCloseClick() {
				this.data.visible = false;
			},
			selectImage(eObj) {
				let ths = this;
				let files = eObj.target.files;
				if (files && files.length > 0) {
					let reader = new FileReader();
					reader.onload = function(e) {
						let imgData;
						if (typeof e.target.result === 'object') {
							imgData = window.URL.createObjectURL(new Blob([e.target.result]))
						} else {
							imgData = e.target.result
						}
						ths.data.option.img = imgData;
						ths.VueCropperRealTime();
					};
					reader.readAsDataURL(files[0]);
				}
			},
			setCurrentImage(url) {
				let ths = this;
				if (url.indexOf('http') > -1) {
					ths.getBase64(url)
						.then(function(base64){
							  console.log(base64);//处理成功打印在控制台
						},function(err){
							  console.log(err);//打印异常信息
						});      
				} else {
					ths.data.option.img = url;
				}
				ths.data.visible = true;
			},
			getBase64(imgUrl) {
				window.URL = window.URL || window.webkitURL;
				var xhr = new XMLHttpRequest();
				xhr.open("get", imgUrl, true);
				// 至关重要
				xhr.responseType = "blob";
				xhr.onload = function () {
					if (this.status == 200) {
						//得到一个blob对象
						var blob = this.response;
						console.log("blob", blob)
						// 至关重要
						let oFileReader = new FileReader();
						oFileReader.onloadend = function (e) {
							// 此处拿到的已经是 base64的图片了
							let base64 = e.target.result;
							console.log("方式一》》》》》》》》》", base64)
						};
						oFileReader.readAsDataURL(blob);
							//====为了在页面显示图片，可以删除====
						var img = document.createElement("img");
						img.onload = function (e) {
							window.URL.revokeObjectURL(img.src); // 清除释放
						};
						let src = window.URL.createObjectURL(blob);
						img.src = src
						//document.getElementById("container1").appendChild(img);
						//====为了在页面显示图片，可以删除====
					}
				}
				xhr.send();
			}
		}
	}
</script>

<style>
	.cropperForm .el-card__header {
		padding: 5px 20px !important;
	}

	.cropperForm .el-card__body {
		padding: 2px !important;
	}
</style>
